import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';

// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Grid, Paper, Typography, Alert, MenuItem } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSettingsContext } from '../../../components/settings';
import FormProvider, { RHFAutocomplete, RHFSelect } from '../../../components/hook-form';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { GridPaper, GridPaperSwitch } from '../../../components/custom-grid-input';
import { updateUserProfile } from '../../../APIs/appUsers';


const classes = {
    root: {
        flexGrow: 1
    },
    paper: {
        padding: 5,
        textAlign: "center",
        color: "inherit"
    }
};

/* eslint-disable react/prop-types */
export const ProfileView = ({ setReload, selectedProfile, profileRolesList, diagnosisList }) => {
    const { themeStretch } = useSettingsContext();
    const axiosPrivate = useAxiosPrivate();

    const [diagnosisValue, setDiagnosisValue] = useState(selectedProfile?.diagnosisId ? { id: selectedProfile?.diagnosisId, name: selectedProfile?.diagnoses } : { id: 0, name: '' });
    const [diagnosisInputValue, setDiagnosisInputValue] = useState(selectedProfile?.diagnosisId ?? '');

    const [profileRolesValue, setProfileRolesValue] = useState(selectedProfile?.profileRoleId ? { id: selectedProfile?.profileRoleId, name: selectedProfile?.profileRole } : { id: 0, name: '' });
    const [ProfileRolesInputValue, setProfileRolesInputValue] = useState(selectedProfile?.profileRoleId ?? '');

    const ProfileSchema = Yup.object().shape({
        id: Yup.number(),
        profileRoleId: Yup.string().nullable().required('Profile Role is required'),
        diagnosisId: Yup.string().nullable().required('Diagnosis is required')
    });

    const defaultValues = {
        id: selectedProfile?.id ?? 0,
        profileRoleId: selectedProfile?.profileRoleId ?? '',
        diagnosisId: selectedProfile?.diagnosisId ?? ''
    };

    const methods = useForm({
        resolver: yupResolver(ProfileSchema),
        defaultValues
    });


    const {
        setValue,
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = methods;

    const handleSave = (request) => {
        const newRequest = { ...request }

        if (request.id > 0) {
            update(newRequest);
        }
    }

    const update = (request) => {
        updateUserProfile(axiosPrivate, request, (response) => {
            if (response.status === 200) {
                setReload();
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    return (
        <>
            <Helmet>
                <title>Update Profile | flok</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'} spacing={{ xs: 0.5, sm: 1.5 }}>
                <FormProvider methods={methods} onSubmit={handleSubmit(handleSave)}>
                    <div style={classes.root}>
                        <Grid container selectedProfile xs={12} spacing={1}>
                            <Grid  selectedProfile xs={6} spacing={1}>
                                <Grid selectedProfile xs={12}>
                                    <Paper style={classes.paper}>
                                        <RHFAutocomplete
                                            name="diagnosisId"
                                            label="Diagnosis *"
                                            value={diagnosisValue}
                                            onChange={(event, newValue) => {
                                                setDiagnosisValue('');
                                                setDiagnosisInputValue('');
                                                setValue('diagnosisId', '', { shouldValidate: true });

                                                if (newValue) {
                                                    setDiagnosisValue(newValue);
                                                    setDiagnosisInputValue(newValue.name ?? '');
                                                    setValue('diagnosisId', parseInt(newValue.id, 10), { shouldValidate: true });
                                                }

                                            }}
                                            inputValue={diagnosisInputValue}
                                            onInputChange={(event, value) => {
                                                if (value) {
                                                    setDiagnosisInputValue(value ?? '');
                                                    setDiagnosisValue(value);
                                                }
                                            }}
                                            getOptionLabel={(option) => option?.name ?? ''}
                                            options={diagnosisList}
                                            freeSolo
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            <Grid selectedProfile xs={6} spacing={1}>
                                <Grid selectedProfile xs={12}>
                                    <Paper style={classes.paper}>
                                        <RHFAutocomplete
                                            name="profileRoleId"
                                            label="Profile Role *"
                                            value={profileRolesValue}
                                            onChange={(event, newValue) => {
                                                setProfileRolesValue('');
                                                setProfileRolesInputValue('');
                                                setValue('profileRoleId', '', { shouldValidate: true });

                                                if (newValue) {
                                                    setProfileRolesValue(newValue);
                                                    setProfileRolesInputValue(newValue.name ?? '');
                                                    setValue('profileRoleId', parseInt(newValue.id, 10), { shouldValidate: true });
                                                }

                                            }}
                                            inputValue={ProfileRolesInputValue}
                                            onInputChange={(event, value) => {
                                                if (value) {
                                                    setProfileRolesInputValue(value ?? '');
                                                    setProfileRolesValue(value);
                                                }
                                            }}
                                            getOptionLabel={(option) => option?.name ?? ''}
                                            options={profileRolesList}
                                            freeSolo
                                        />
                                    </Paper>
                                </Grid>
                            </Grid>
                            <Grid selectedProfile xs={12} spacing={0}>
                                <Grid selectedProfile xs={2}>
                                    <Paper style={classes.paper}>
                                        <LoadingButton
                                            type="submit"
                                            variant="contained"
                                            loading={isSubmitSuccessful || isSubmitting}
                                        >
                                            Update
                                        </LoadingButton>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </FormProvider>
            </Container>
        </>
    )
}